import { gql } from '@apollo/client';

export const ALL_DISAGGREGATIONS = gql`
  query AllDisaggregations {
    disaggregations: allDisaggregations {
      id
      name
      query
      values {
        name
      }
    }
  }
`;
